<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm9.5 10.8h-3.8c-.1-3.1-.8-5.7-1.8-7.6 3 1.3 5.2 4.2 5.6 7.6zM12 21.3c-1.2 0-3-3.1-3.3-8.1h6.5c-.2 5-2 8.1-3.2 8.1zM8.7 10.8c.3-5 2-8.1 3.3-8.1s3 3.1 3.3 8.1H8.7zm-.5-7.6c-1 1.9-1.7 4.5-1.8 7.6H2.5c.4-3.4 2.6-6.3 5.7-7.6zm-5.7 10h3.8c.1 3.1.8 5.7 1.8 7.6-3-1.3-5.2-4.2-5.6-7.6zm13.3 7.6c1-1.9 1.7-4.5 1.8-7.6h3.8c-.3 3.4-2.5 6.3-5.6 7.6z"
    />
  </svg>
</template>
